/* CREAMORE — 购物车交互（乐观反馈 + 首页卡片加购）

   header 是自写的 creamore-header.liquid，没有 Horizon 的 cart-drawer-component，
   角标 .cr-cart-count 只由服务端渲染，加购后页面毫无变化。

   ⚠️ 坑 1：购物车为空时 .cr-cart-count 根本不存在（header 里是条件渲染）。
   “只更新已有元素”的写法在【空车 → 加 1 件】这个最常见场景下完全无效，必须 badge() 现建。

   ⚠️ 坑 2：点商品页主按钮时，主题会连带触发 sticky-add-to-cart 悬浮条上那个
   按钮（实测相隔 8ms），会多加一件。用 600ms 冷却挡掉。

   ⚠️ 坑 3：分类页 quick-add 有两种按钮，都是 name="add"、都在 /cart/add 表单里，
   只能按 class 分：--add 是真加购，--choose 只是打开变体选择器（不能算加购）。

   ⚠️ 坑 4：首页 creamore-featured-products 里的 .cr-atc-btn 是个裸 <button>，
   只有 data-variant-id，既不在表单里也从来没绑过事件 —— 点下去真的什么都不会发生。
   这里补上它的加购行为。（同一个 section 里的“Choose options”是 <a> 跳详情页，本来就对。）

   时序：点击瞬间先动（乐观）→ /cart.js 回来用真实值校正。
*/
(function () {
  if (window.__crCartFeedback) return;
  window.__crCartFeedback = true;

  var MUTATE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var ADD_SEL = 'button[name="add"], .add-to-cart-button, add-to-cart-component button, [data-add-to-cart], .cr-atc-btn';
  var COOLDOWN = 600;
  var lastClick = 0;
  var timer = null;

  function badge() {
    var el = document.querySelector('.cr-cart-count');
    if (el) return el;
    var btn = document.querySelector('a.cr-cart-btn') || document.querySelector('a[href$="/cart"]');
    if (!btn) return null;
    el = document.createElement('span');
    el.className = 'cr-cart-count';
    btn.appendChild(el);
    return el;
  }

  function paint(n, bump) {
    var el = badge();
    if (!el) return;
    el.textContent = n;
    if (n < 1) { el.style.display = 'none'; return; }
    el.style.display = '';
    if (bump) {
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    }
  }

  function current() {
    var el = document.querySelector('.cr-cart-count');
    if (!el || el.style.display === 'none') return 0;
    var n = parseInt(el.textContent, 10);
    return isNaN(n) ? 0 : n;
  }

  var toastEl = null;
  function toast() {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cr-cart-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML =
      '<span class="cr-cart-toast-tick" aria-hidden="true"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
      '<span class="cr-cart-toast-text">Added to cart</span>' +
      '<a class="cr-cart-toast-link" href="/cart">View cart &rarr;</a>';
    toastEl.classList.remove('is-in');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-in');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-in'); }, 4000);
  }

  function reconcile() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(c.item_count, false); })
        .catch(function () {});
    }, 80);
  }

  function isRealAdd(btn) {
    if (!btn || btn.disabled) return false;
    if (btn.getAttribute('aria-disabled') === 'true') return false;
    if (btn.classList.contains('quick-add__button--choose')) return false;
    if (btn.getAttribute('aria-haspopup') === 'dialog') return false;
    return true;
  }

  /* 1) 乐观：点击瞬间就动，不等网络 */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(ADD_SEL);
    if (!isRealAdd(btn)) return;

    var now = Date.now();
    if (now - lastClick < COOLDOWN) return;
    lastClick = now;

    var form = btn.closest('form');
    var qtyEl = form && form.querySelector('input[name="quantity"]');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
    if (isNaN(qty) || qty < 1) qty = 1;

    paint(current() + qty, true);
    toast();
  }, true);

  /* 2) 首页卡片的裸按钮：自己发加购请求 */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.cr-atc-btn[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = Number(btn.dataset.variantId);
    if (!id) return;
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .catch(function () {})            /* 失败也不报错：reconcile 会把角标拉回真实值 */
      .then(function () { btn.disabled = false; });
  }, false);

  /* 3) 校正：任何购物车写操作回来后拉真实值 */
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var hit = MUTATE.test(url);
    return _fetch.apply(this, arguments).then(function (res) {
      if (hit) reconcile();
      return res;
    });
  };

  ['cart:update', 'cart:updated', 'CartUpdate'].forEach(function (ev) {
    document.addEventListener(ev, reconcile);
  });

  window.addEventListener('pageshow', function (e) { if (e.persisted) reconcile(); });
})();
